import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#BABEC1",
      "fill-rule": "evenodd",
      d: "M12 21.251a9.25 9.25 0 0 0 9.25-9.25A9.25 9.25 0 0 0 12 2.751a9.25 9.25 0 0 0-9.25 9.25 9.25 9.25 0 0 0 9.25 9.25m.412-13.404a.75.75 0 0 0-1.5 0v4.847a.75.75 0 0 0 .365.644l3.77 2.25a.75.75 0 0 0 .769-1.289l-3.404-2.03z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }